import React from 'react';
import PropTypes from 'prop-types';
import { ButtonDropdown as ButtonDropdownUI } from 'xland-ui';

function ButtonDropdown({ color, buttons = [], ...props }) {
  return (
    <ButtonDropdownUI
      {...props}
      variant={color || 'primary'}
      buttons={buttons}
    />
  );
}

ButtonDropdown.propTypes = {
  text: PropTypes.string.isRequired,
  align: PropTypes.string,
  color: PropTypes.string,
  buttons: PropTypes.array,
};

export default ButtonDropdown;
